import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "success" | "warning" | "destructive" | "secondary";
}

export function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        {
          "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300": variant === "default",
          "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300": variant === "success",
          "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300": variant === "warning",
          "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300": variant === "destructive",
          "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300": variant === "secondary",
        },
        className,
      )}
      {...props}
    />
  );
}
